module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "fixed-top",
    class: {
      'transparent': _vm.scrollPosition < 100,
      'bg-primary': _vm.scrollPosition > 100
    },
    attrs: {
      "id": "navigation"
    }
  }, [_c('div', {
    staticClass: "container-fluid",
    attrs: {
      "id": "status-bar"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3 col-lg-2 offset-md-9 offset-lg-10"
  }, [_c('div', {
    staticClass: "wrap float-right"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "languages"
  }, [(_vm.currentLanguage === 'sr') ? _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.changeLanguage($event)
      }
    }
  }, [_vm._v("English")]) : _vm._e(), _vm._v(" "), (_vm.currentLanguage === 'en') ? _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.changeLanguage($event)
      }
    }
  }, [_vm._v("Srpski")]) : _vm._e()])])])])]), _vm._v(" "), _c('nav', {
    staticClass: "navbar navbar-toggleable-md navbar-inverse"
  }, [_vm._m(1), _vm._v(" "), _c('router-link', {
    staticClass: "navbar-brand",
    attrs: {
      "to": {
        name: 'home'
      },
      "tag": "a"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./assets/logo.svg"),
      "alt": "MONS platforma"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse",
    attrs: {
      "id": "navbarSupportedContent"
    }
  }, [_c('div', {
    staticClass: "navbar-nav"
  }, [_c('li', {
    staticClass: "nav-item",
    attrs: {
      "data-toggle": "collapse",
      "data-target": ".navbar-collapse.show"
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'home'
      },
      "exact": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('navigation.home')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item dropdown"
  }, [_c('a', {
    staticClass: "nav-link dropdown-toggle",
    class: this.$route.path.includes('/about') ? 'router-link-active' : '',
    attrs: {
      "href": "#",
      "id": "navbarDropdownMenuLink",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v("MONS")]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu",
    attrs: {
      "aria-labelledby": "navbarDropdownMenuLink",
      "data-toggle": "collapse",
      "data-target": ".navbar-collapse.show"
    }
  }, [_c('router-link', {
    staticClass: "dropdown-item",
    attrs: {
      "to": {
        name: 'about'
      },
      "data-toggle": "collapse",
      "data-target": ".navbar-collapse.show"
    }
  }, [_vm._v(_vm._s(_vm.$t('navigation.about')))]), _vm._v(" "), _c('router-link', {
    staticClass: "dropdown-item",
    attrs: {
      "to": {
        name: 'initiators'
      },
      "data-toggle": "collapse",
      "data-target": ".navbar-collapse.show"
    }
  }, [_vm._v(_vm._s(_vm.$t('navigation.initiators')))]), _vm._v(" "), _c('router-link', {
    staticClass: "dropdown-item",
    attrs: {
      "to": {
        name: 'aboutAuthors'
      },
      "data-toggle": "collapse",
      "data-target": ".navbar-collapse.show"
    }
  }, [_vm._v(_vm._s(_vm.$t('navigation.aboutAuthors')))])], 1)]), _vm._v(" "), _c('li', {
    staticClass: "nav-item",
    attrs: {
      "data-toggle": "collapse",
      "data-target": ".navbar-collapse.show"
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'key_articles'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('navigation.key_articles')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item",
    attrs: {
      "data-toggle": "collapse",
      "data-target": ".navbar-collapse.show"
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'blog'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('navigation.blog')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item",
    attrs: {
      "data-toggle": "collapse",
      "data-target": ".navbar-collapse.show"
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'video'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('navigation.video')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item",
    attrs: {
      "data-toggle": "collapse",
      "data-target": ".navbar-collapse.show"
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'infographics'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('navigation.infographics')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item",
    attrs: {
      "data-toggle": "collapse",
      "data-target": ".navbar-collapse.show"
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'contact'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('navigation.contact')))])], 1), _vm._v(" "), _c('search-component', {
    class: {
      'transparent': _vm.scrollPosition < 100,
      '': _vm.scrollPosition > 100
    },
    attrs: {
      "id": "search"
    }
  })], 1)])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid main-content"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('router-view', {
    attrs: {
      "chapter": _vm.currentChapter,
      "language": _vm.currentLanguage,
      "chapters": _vm.chapters
    },
    on: {
      "chapterChanged": _vm.chapterChanged,
      "languageChanged": _vm.languageChanged
    }
  })], 1)], 1), _vm._v(" "), _c('footer-view')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "social-media"
  }, [_c('a', {
    attrs: {
      "href": "https://www.facebook.com/monitoring.mons/",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook-official",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://twitter.com/monitoring_MONS",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter-square",
    attrs: {
      "aria-hidden": "true"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "navbar-toggler navbar-toggler-right",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#navbarSupportedContent",
      "aria-controls": "navbarSupportedContent",
      "aria-expanded": "false",
      "aria-label": "Toggle navigation"
    }
  }, [_c('span', {
    staticClass: "navbar-toggler-icon"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-83f76b3e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 514
// module chunks = 1